import React from "react"
import { GMapApiKey, DefaultMapLatitude, DefaultMapLongitude } from "../../config/Constants"
import GoogleMapReact from "google-map-react"
import CollectionSite from "../../api/Location/LocationModel/CollectionSite"


const handleApiLoaded = (map: any, maps: any, sites: CollectionSite[]) => {
  const markers: any[] = []
  const infoWindows: any[] = []

  sites.forEach((site) => {
    markers.push(new maps.Marker({
      position: {
        lat: site.Latitude,
        lng: site.Longitude,
      },
      map,
    }))

    infoWindows.push(new maps.InfoWindow({ content: getInfoWindowString(site) }))
  })
  if (markers.length) {
    var bounds = new google.maps.LatLngBounds()
    markers.forEach((marker, i) => {
      marker.addListener("click", () => {
        infoWindows.forEach((infoWindow) => infoWindow.close(map))
        infoWindows[i].open(map, marker)
      })
      bounds.extend(marker.position)
    })
    map.fitBounds(bounds);
  }
}

const getInfoWindowString = (site: CollectionSite) => `
  <table>
    <thead><tr><th colspan="2"><h3 class="info-window-head">${site.Name}</h3><th><tr></thead>
    <tr><td class="info-window-content">Phone:</td><td>${site.Phone}</td></tr>
    <tr><td class="info-window-content">Fax:</td><td>${site.Fax}</td></tr>
    <tr><td class="info-window-content">Hours:</td><td>${site.HoursOfOperation}</td></tr>
    <tr><td class="info-window-content">Distance:</td><td>${site.Distance && site.Distance.toFixed(2)} Miles</td></tr>
    </tbody></table>
    <div><div class="col-xs-4 padding-zero info-window-content">Services:</div><div class="scroll-info-window padding-zero col-xs-8"><ul class="info-window-ul">${site.VendorService ? site.VendorService.map(service => { `<li>${service}</li>` }) : ""}</ul></div></div>
  `

interface MapContainerProps {
  sites: CollectionSite[]
  center: {
    lat: number,
    lng: number
  },
  zoom: number
}

export default class MapContainer extends React.Component<MapContainerProps, { mapReactKey: string }> {
  state = { mapReactKey: Math.random().toString() }

  componentDidUpdate(prevProps: MapContainerProps) {
    if (this.props.sites !== prevProps.sites) {
      this.setState({ mapReactKey: Math.random().toString() })
    }
  }

  render() {
    const { sites } = this.props
    const style = {
      width: "100%",
      height: "600px"
    }
    return (
      <div style={style}>
        <GoogleMapReact
          key={this.state.mapReactKey}
          bootstrapURLKeys={{ key: GMapApiKey, language: "en" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
          options={{ mapTypeControl: true }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps, sites)}>
        </GoogleMapReact>
      </div>
    )
  }

  static defaultProps = {
    center: {
      lat: DefaultMapLatitude,
      lng: DefaultMapLongitude
    },
    zoom: 1
  }
}
